export function trustedByCompaniesSlider() {
    let $slider = $('.trusted-by-companies-slider');
    $slider.slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 15000,
        pauseOnHover: false,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1800,
                settings: {
                    slidesToShow: 6
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/trustedByCompaniesSlider.js